import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import NotificationCenter from './NotificationCenter'
import { getRoleName, getRoleColor } from '../utils/roleUtils'
import { 
  HomeIcon, 
  ChartBarIcon, 
  UserIcon,
  ArrowLeftOnRectangleIcon,
  ArrowRightOnRectangleIcon,
  CogIcon,
  UsersIcon
} from '@heroicons/react/24/outline'

function Layout({ children }) {
  const { user, logout, hasPermission, isAdmin } = useAuth()
  const location = useLocation()

  const navigation = [
    { name: 'Inicio', href: '/', icon: HomeIcon },
    { name: 'Dashboard', href: '/dashboard', icon: ChartBarIcon },
  ]

  // Agregar rutas de administración si el usuario es admin
  if (isAdmin()) {
    navigation.push(
      { name: 'Usuarios', href: '/admin/users', icon: UsersIcon },
      { name: 'Configuración', href: '/admin/settings', icon: CogIcon }
    )
  }

  return (
    <div className="min-h-full">
      <nav className="bg-white shadow-sm">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 justify-between">
            <div className="flex">
              <div className="flex flex-shrink-0 items-center">
                <Link to="/" className="flex items-center space-x-2">
                  <img
                    className="h-8 w-auto"
                    src="/logo.svg"
                    alt="Domus"
                  />
                  <span className="text-xl font-bold text-primary-600">Domus</span>
                </Link>
              </div>
              <div className="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                {navigation.map((item) => {
                  const current = location.pathname === item.href
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`${
                        current
                          ? 'border-primary-500 text-gray-900'
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                      } inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium`}
                    >
                      <item.icon className="h-5 w-5 mr-2" />
                      {item.name}
                    </Link>
                  )
                })}
              </div>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:items-center space-x-4">
              {user && <NotificationCenter />}
              {user ? (
                <div className="flex items-center space-x-4">
                  <div className="flex flex-col items-end">
                    <span className="text-sm text-gray-700">
                      Hola, {user.name || user.email}
                    </span>
                    {user.role && (
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getRoleColor(user.role)}`}>
                        {getRoleName(user.role)}
                      </span>
                    )}
                  </div>
                  <button
                    onClick={logout}
                    className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-500 hover:text-gray-700"
                  >
                    <ArrowLeftOnRectangleIcon className="h-5 w-5 mr-1" />
                    Salir
                  </button>
                </div>
              ) : (
                <Link
                  to="/login"
                  className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-500 hover:text-gray-700"
                >
                  <ArrowRightOnRectangleIcon className="h-5 w-5 mr-1" />
                  Iniciar Sesión
                </Link>
              )}
            </div>
          </div>
        </div>
      </nav>

      <main className="py-6">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>
    </div>
  )
}

export default Layout